import { useTranslation } from 'react-i18next';
import { Pager } from '@/shared/ui/pager';

export interface SelectorPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  variant?: 'plain' | 'boxed';
}

/**
 * Stránkování dropdownu/modalu Selectoru — tenký wrapper nad sdíleným idiomem
 * « ‹ … › » (`@/shared/ui/pager`), který používá i patička ListPage.
 */
export function SelectorPagination({
  currentPage,
  totalPages,
  onPageChange,
  variant = 'plain',
}: SelectorPaginationProps) {
  const { t } = useTranslation('asyncSelector');

  return (
    <Pager
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      variant={variant}
      info={t('footer.pageInfo', { current: currentPage, total: totalPages })}
      labels={{
        first: t('footer.firstPage'),
        previous: t('footer.previousPage'),
        next: t('footer.nextPage'),
        last: t('footer.lastPage'),
      }}
      testIds={{
        root: 'selector-pagination',
        first: 'pagination-first',
        previous: 'pagination-previous',
        next: 'pagination-next',
        last: 'pagination-last',
        info: 'pagination-info',
      }}
    />
  );
}
